import {initWebComponent} from "@/helpers/web-component-helper";

export class GuidelinesComponent extends HTMLElement {
    constructor() {
        super();

        const guideLines = wizard.guidelines

        const template = document.createElement('template');

        let links = ''
        for (const [key, value] of Object.entries(window.wizard.contactDetails)) {
            links += generateLink(key, value)
        }

        template.innerHTML = `
<div class="home-item" id="imgPhotoGuideLines" style="margin-top:100px">
</div>
<div class="container mt-5 mb-5">
    <div class="row">
        <div class="col-12">
          <h1 class="text-primary" id="guidelinesTitle">${guideLines.title}</h1>
          <p class="text-primary" id="guidelinesText">${guideLines.text.replaceAll('\n', '<br/>')}</p>
        </div>
    </div>
</div>
<div id="footer">
    <div class="home-item-footer" style="background-color:#545F5B">
            <div class="container">
              <div class="row text-white pt-5 pb-5 d-flex">
                <div class="col-12">
                    <div class="text-right">
                      <div class="divContactUrls">${links}</div>
                      <p class="mt-1 mb-1 contactDetailsText">${window.wizard.contactDetails.ContactText}</p>
                      <a class="link link-white aContactUrl" target="_blank">Contact</a>
                    </div>
                </div>
              </div>
            </div>
          </div>
</div>
`;

        initWebComponent(this, template)

        function generateLink(key, value) {

            switch (key) {
                case 'ContactUrlFacebook':
                    return `<a class="link link-white" href="${value}" target="_blank">
                    <span class="fab fa-facebook-square fa-2x ml-2"></span>
                    </a>`
                case 'ContactUrlTwitter':
                    return `<a class="link link-white" href="${value}" target="_blank">
                    <span class="fab fa-twitter-square fa-2x ml-2"></span>
                    </a>`
                case 'ContactUrlLinkedIn':
                    return `<a class="link link-white" href="${value}" target="_blank">
                    <span class="fab fa-linkedin fa-2x ml-2"></span>
                    </a>`
                case 'ContactUrlYouTube':
                    return `<a class="link link-white" href="${value}" target="_blank">
                    <span class="fab fa-youtube-square fa-2x ml-2"></span>
                    </a>`
                case 'ContactUrlInstagram':
                    return `<a class="link link-white" href="${value}" target="_blank">
                    <span class="fab fa-instagram-square fa-2x ml-2"></span>
                    </a>`
            }

            return ''
        }
    }
}
